import store from '@/store'

export function checkIamAction(endpoint, resource_type, action) {
  if (!endpoint || !resource_type || !action) {
    return false
  }

  const iamActions = store && store.getters ? store.getters.iamActions : null

  if (iamActions === null || iamActions === undefined) {
    return true
  }

  if (!Array.isArray(iamActions) || !iamActions.length) {
    return false
  }

  const target = iamActions.find(
    (item) => item.endpoint === endpoint
  )

  // const target = iamActions.find(
  //   (item) => item.endpoint === endpoint && item.resource_type === resource_type
  // )

  if (!target || !target.actions) {
    return false
  }

  const upperAction = typeof action === 'string' ? action.toUpperCase() : action
  return Boolean(target.actions[upperAction] || target.actions[action])
}

export const ACTION_TO_IAM_MAP = {
  add: 'CREATE',
  create: 'CREATE',
  import: 'CREATE',
  edit: 'UPDATE',
  update: 'UPDATE',
  translate: 'UPDATE',
  synchronize: 'UPDATE',
  booking: 'UPDATE',
  browser: 'UPDATE',
  unbrowser: 'UPDATE',
  delete: 'DELETE',
  detail: 'GET',
  showQR: 'GET',
  copy: 'GET',
  related: 'GET',
  export: 'GET',
  cashier: 'GET',
  cook: 'GET',
  public: 'ENABLE',
  private: 'ENABLE',
  filter: 'GET',
  tag: 'UPDATE'
}

export function getResourceInfo(type) {
  const IAM_PLACE_TYPES = [
    'activity', 'area', 'attraction', 'buddhist-learning', 'buddhist-scripture', 'campaign',
    'cemetery', 'church', 'commerce', 'commerce-tour', 'company', 'contact', 'country',
    'craft-village', 'cuisine', 'dashboard', 'document', 'document-library', 'entertainment',
    'event', 'family', 'festival', 'financial', 'golf', 'government-agency', 'health', 'image',
    'image-library', 'kiosk', 'lookup', 'museum', 'music', 'news', 'other', 'people',
    'policy-communication', 'post', 'press', 'qna', 'real-estate', 'refuge', 'restaurant',
    'reviewer', 'sound-library', 'stay', 'tour', 'tour-guide', 'trade', 'traffic',
    'transportation', 'travel-experience', 'video', 'video-library', 'volunteer'
  ]

  if (IAM_PLACE_TYPES.includes(type)) {
    return { endpoint: '/place', resource_type: type }
  }
  return { endpoint: type ? `/${type}` : '', resource_type: 'API' }
}
